var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BasePageContainer',[_c('SettingHeader',[_vm._v(" テンプレート追加 ")]),_c('div',{staticClass:"pt-10 pb-4"},[(_vm.initialized)?_c('MandalaGoalTemplateForm',{attrs:{"mandala-goal-template":_vm.mandalaGoalTemplate,"response-errors":_vm.responseErrors},on:{"submit":_vm.submit}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }